<script>
import ImageProduct from "@/components/products/viewProduct/ImageProduct.vue";
import InformationProduct from "@/components/products/viewProduct/InformationProduct.vue";
import HistoryCreatingBeer from "@/components/products/viewProduct/HistoryCreatingBeer.vue";
import OtherProduct from "@/components/products/viewProduct/OtherProduct.vue";
import ProductReview from "@/components/reviews/product/ProductReview.vue";
import {api} from "@/modules/api";

export default {
  name: 'DetailsProduct',
  components: {ProductReview, OtherProduct, HistoryCreatingBeer, InformationProduct, ImageProduct},
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      reviews: {}
    }
  },
  mounted () {
    this.loadData()
    this.emitter.on('load-data', () => {
      this.loadData()
    })
  },
  computed: {
    color () {
      return this.product.color
    }
  },
  methods: {
    async loadData () {
      this.reviews = await api.reviews.get(this.product.id)
    }
  }
}
</script>

<template>
  <div class="max-w-screen-xl lg:px-4 mx-auto 2xl:px-0">
    <div class="lg:min-h-screen lg:grid lg:grid-cols-2 lg:gap-8 xl:gap-16 px-4">
      <div>
        <div class="relative lg:absolute w-full h-5/6 left-0 lg:-left-1/2 rounded-full z-0 flex items-center justify-end" :style="{'background-color': color}">
          <image-product :product="product" />
        </div>
      </div>
      <div class="mt-6 sm:mt-8 lg:mt-0">
        <information-product v-if="product.Reviews" :product="product" />
      </div>
    </div>
    <history-creating-beer />
    <other-product v-if="product.category" :category="product.category" />
    <ProductReview :product="product" :reviews="reviews" />
  </div>
</template>
